// client/src/utils/computeStakeRange.ts
//
// Bucketiza el buy-in total de un torneo en uno de los rangos usados por
// population_benchmarks. Los buckets son los mismos que el schema de
// player_stats esperaba desde migration_001.sql.
//
// Definición: "buy-in total" = lo que al user le costó jugar. Incluye
// bounty, rake, y todo lo demás. Si `rebuys > 0`, NO se suma — cada rebuy
// cuenta como una "nueva entrada" en el mismo bucket, no mueve el torneo
// a un bucket mayor.
//
// Freerolls y tickets (buy-in = 0) se meten en '$1-5' para no crear un
// bucket especial de bajo volumen.

export type StakeRange = '$1-5' | '$5-15' | '$15-50' | '$50+';

export function computeStakeRange(buyIn: number): StakeRange {
  if (buyIn < 5) return '$1-5';       // incluye freerolls y < $5
  if (buyIn < 15) return '$5-15';     // $5.00 a $14.99
  if (buyIn < 50) return '$15-50';    // $15.00 a $49.99
  return '$50+';                       // $50 en adelante
}
